import React from 'react';
import {useDispatch} from 'react-redux';

import {AppButton} from '@/components/Button';
import ROUTE_PATHS from '@/consts/route/routePaths';
import HomePageTopNavigation from '@/containers/HomePageTopNavigation/HomePageTopNavigation';
import useIsMobileLayout from '@/hooks/layout/useIsMobileLayout';
import {showConnectionCancellationModalAction} from '@/state/slices/modalSlice';
import {twx} from '@/utils/tailwindUtils';
import HomePageLayout from '@/views/Home/HomePageLayout';
import {WARNING_BANNER_SOURCE_TYPES, WarningBanners, WarningBannersTop} from '@/views/WarningBanners';

const ConnectionPageLayout = ({children, className}) => {
    const isMobile = useIsMobileLayout();

    return isMobile ? (
        children
    ) : (
        <HomePageLayout
            className={twx('md:px-8 ml:flex ml:flex-col ml:items-center ml:bg-primary-dark-5 lg:px-16', className)}
            activePath={ROUTE_PATHS.DEVICES_PAGE}
        >
            <WarningBannersTop source={WARNING_BANNER_SOURCE_TYPES.CONNECTION} />
            <HomePageTopNavigation profileControlsClassName='bg-romance' />
            {children}
            <WarningBanners source={WARNING_BANNER_SOURCE_TYPES.CONNECTION} />
        </HomePageLayout>
    );
};

const Header = ({title, button}) => {
    const isMobile = useIsMobileLayout();
    const dispatch = useDispatch();

    if (isMobile) return null;

    const handleClick = () => {
        dispatch(showConnectionCancellationModalAction());
    };

    return (
        <div className='mt-sticky-header flex w-full max-w-[1016px] items-center justify-between rounded-[100px] bg-secondary px-8 py-4 lg:max-w-[1336px]'>
            <h2 className='m-0 text-18 tracking-04'>{title}</h2>
            {button && (
                <AppButton tertiaryNoUnderline aria-label={button?.alt} onClick={handleClick}>
                    {button?.text}
                </AppButton>
            )}
        </div>
    );
};

ConnectionPageLayout.Header = Header;

export default ConnectionPageLayout;
